export default () => {
  return window.location.origin === process.env.VUE_APP_KIOSK_URL;
}
